module.exports = __webpack_public_path__ + "img/avatar_8.20beb497.svg";